import { render, staticRenderFns } from "./ToStatementButtonActivity.vue?vue&type=template&id=974706f2&"
import script from "./ToStatementButtonActivity.vue?vue&type=script&lang=js&"
export * from "./ToStatementButtonActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports